import { WatchQueryFetchPolicy } from '@apollo/client'

import { ImportRoomUsersJobTranslator } from 'src/translators'
import { useGetLatestImportRoomUsersJobQuery } from 'src/types/generated'

type Input = {
  isEnabledPolling?: boolean
  fetchPolicy?: WatchQueryFetchPolicy
}
export const useGetLatestImportRoomUsersJob = (input?: Input) => {
  const { loading, data, error, refetch } = useGetLatestImportRoomUsersJobQuery({
    // NOTE: 3秒ごとにポーリングする。0を設定することでポーリングを停止する
    pollInterval: input?.isEnabledPolling ? 1000 * 3 : 0,
    fetchPolicy: input?.fetchPolicy,
  })

  return {
    loading,
    importRoomUsersJob: data
      ? ImportRoomUsersJobTranslator.toEntity(data.latestImportRoomUsersJob)
      : undefined,
    error,
    refetch,
  }
}
